import React from 'react'
import { Outlet } from 'react-router-dom'
import AboutTopic from './AboutTopic'
import { Helmet } from 'react-helmet-async'


const AboutLayout = () => {
  return (
    <div>
      <Helmet>
        <title>About Us</title>
        <meta property='og:title' content=' About Us' />
        <meta property='og:description' content=' A complete solution for Company Registration' />
      </Helmet>
      <AboutTopic />
      <div>
        <Outlet />
      </div>


    </div>
  )
}

export default AboutLayout